// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import history from './history';

const checkToken = (body) => {
  const TOKEN_ERROR_MESSAGES = ['Not Authorized.', 'Invalid Auth Token'];
  if (body && TOKEN_ERROR_MESSAGES.includes(body.Reason)) {
    localStorage.removeItem('loggedID');
    localStorage.removeItem('CartID');
    localStorage.removeItem('token');
    localStorage.removeItem('TradeCustomer');
    localStorage.removeItem('PaymentTypeForTradeCustomer');
    localStorage.removeItem('total');
    localStorage.removeItem('isBookshop');
    history.push('login', {
      tokenError: true,
      message: 'You have been logged out. Please log in to continue.',
    });
  }
};

const fetchAPI = (path, options) => {
  return fetch(path, options)
    .then((resp) => {
      return resp.json()
        .then((body) => {
          if (!resp.ok) {
            checkToken(body);
          }
          return { ok: resp.ok, body };
        });
    })
    .catch((error) => {
      return {
        ...error
      };
    });
};

export default function api(path, params, method) {
  const options = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    method,
    ...(params && method !== 'GET' && { body: JSON.stringify(params) })
  };
  const result = fetchAPI(path, options);
  return result;
}
